import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleProp, StyleSheet, TouchableOpacity, ViewStyle } from 'react-native';

import { useNavigation } from '@react-navigation/native';

import RichText, { ParsedTypes } from '@/components/RichText';
import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { useModals } from '@/feature/alerts/hooks/use-modals';
import { RichTextField } from '@prismicio/client';

type TermsAndConditionsProps = {
    info?: RichTextField | string;
    link?: string;
    style?: StyleProp<ViewStyle>;
};

export const TermsAndConditions = ({ info, link, style }: TermsAndConditionsProps) => {
    const { t } = useTranslation('promohub');
    const navigation = useNavigation();
    const { dismissAll } = useModals();
    const showInfoAndTcLink = !!info;

    const handleTermsAndConditionsPress = () => {
        if (showInfoAndTcLink) {
            dismissAll();
        }
        if (link) {
            navigation.navigate('ModalWebView', { uri: link });
        }
    };

    const isString = typeof info === 'string';

    const localStyle = {
        paddingTop: showInfoAndTcLink ? 32 : 16,
        paddingHorizontal: showInfoAndTcLink ? 16 : 0,
    };

    return (
        <Box style={[localStyle, style]}>
            <Text>
                {info ? (
                    isString ? (
                        <Text
                            color={ds.colorToken.text.secondary}
                            letterSpacing={-0.08}
                            variant={'bodySmall'}
                            mb={'s24'}
                        >
                            {info}
                        </Text>
                    ) : (
                        <RichText
                            data={info}
                            typeProps={{
                                [ParsedTypes.P]: {
                                    textAlign: 'center',
                                    color: ds.colorToken.text.secondary,
                                    variant: 'labelLarge',
                                    letterSpacing: -0.08,
                                },
                            }}
                        />
                    )
                ) : null}
                <Row alignItems={'center'} style={styles.termsAndConditions}>
                    <TouchableOpacity onPress={handleTermsAndConditionsPress}>
                        <Text
                            variant={showInfoAndTcLink ? 'labelLarge' : 'bodyMedium'}
                            fontWeight={showInfoAndTcLink ? '600' : '400'}
                            color={showInfoAndTcLink ? ds.colorToken.text.secondary : ds.colorToken.text.primary}
                            textDecorationLine={'underline'}
                            lineHeight={16}
                        >
                            {t('terms_and_conditions')}
                        </Text>
                    </TouchableOpacity>
                    <Text
                        variant={showInfoAndTcLink ? 'labelLarge' : 'bodyMedium'}
                        color={showInfoAndTcLink ? ds.colorToken.text.secondary : ds.colorToken.text.primary}
                        textAlign={'center'}
                    >
                        {t('apply')}
                    </Text>
                </Row>
            </Text>
        </Box>
    );
};

const styles = StyleSheet.create({
    termsAndConditions: {
        marginTop: -2,
    },
});
